import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectDetailStatus {
  InProgress = 0,
  EDDALocked = 1,
  Closed = 2,
  Cancelled = 3,
  Invoiced = 4,
}

export const projectDetailStatusOptions = mapEnumToOptions(ProjectDetailStatus);
